import React, { Component } from "react";

import { ProtocolTask } from "./components/ProtocolTask";
import { NotesView } from "./components/NotesView";
import { LogEvent } from "@learningblocks/shared-components";

import { TaskTracker } from "../ProtocolOptions/components/TaskTracker"

// Styles
import colors from "@learningblocks/protocol-constants/lib/Styles/_exports.module.scss";
import "./style.scss";

//Icons
import IconNotebook from "@learningblocks/protocol-constants/lib/Icons/notebook-solid";
import IconHexagon from "@learningblocks/protocol-constants/lib/Icons/hexagon-solid";
import IconStart from "@learningblocks/protocol-constants/lib/Icons/start-solid";

export class ProtocolOptions extends Component {
  renderProgress = () => {
    return (
      <div>
        <div className="progress">{this.renderProgressBar()}</div>
        <span className="progress-step">
          {this.props.currentPage}/{this.props.totalPages}
        </span>
      </div>
    );
  };

  renderProgressBar = () => {
    //const currentPage = this.props.currentPage

    return this.props.taskPages.map((task, index) => (
      <LogEvent
        logEventProps={{
          event_type: "sim_protocol_part viewed",
          event_schema: "protocolpart",
          part_number: index +1
        }}
        actionProps={{ onClick: { action: 'clicked' } }}
        elementType="button"
      >
        <div
          className={
            "progress-bar" +
            (this.props.currentPage >= index + 1 ? " active" : "")
          }
          onClick={() => {
            this.pageInstruction.focus();
            this.taskList.scrollTop = 0;
            this.props.goProtocolPage(index + 1);
          }}
          key={index}
          aria-label="protocol section progress bar"
          role="progressbar"
          style={{ width: 100 / this.props.totalPages + "%" }}
          aria-valuenow="15"
          aria-valuemin="0"
          aria-valuemax="100"
        ></div>
      </LogEvent>
    ));
  };

  renderPageInstructions = () => {
    if (this.props.taskPages.length > 0) {
      return (
        <p
          tabIndex="0"
          ref={(pageInstruction) => {
            this.pageInstruction = pageInstruction;
          }}
          className="section-instruction"
        >
          {this.props.currentPage}.{" "}
          {this.props.taskPages[this.props.currentPage - 1].instruction}
        </p>
      );
    } else {
      return <p className="section-instruction">0. No tasks found</p>;
    }
  };

  getAlphabetIndex = (index) => {
    if (index >= 26) {
      let upperIndex = Math.floor(index / 25);
      let delta = index - 25 * upperIndex;

      return (
        String.fromCharCode(96 + upperIndex) + String.fromCharCode(96 + delta)
      );
    }
    return String.fromCharCode(97 + index);
  };

  renderTaskPage = () => {
    if (this.props.taskPages.length > 0) {
      const currentPage = this.props.currentPage;
      //Return list of tasks for rendering

      return (
        <>
          <LogEvent
            logEventProps={{
              event_type: "sim_protocol_step completed",
              event_schema: "protocolstep",
              step_number: this.getAlphabetIndex(this.props.focusedTask),
              part_number: currentPage,
              total_steps: this.props.taskPages.reduce((count, innerArray) => count + innerArray.tasks.length, 0),
            }}
            actionProps={{ setTaskCompleted: { action: 'complete' } }}
            elementType="button"
          >
            {this.props.taskPages[currentPage - 1].tasks.map((task, index) => (
              <ProtocolTask
                key={index}
                pIndex={currentPage - 1}
                tIndex={task.index}
                level={"l" + this.props.level}
                page={currentPage}
              />
            ))}

           <TaskTracker setTaskCompleted={this.props.setTaskCompleted} />
          </LogEvent>
        </>
      );
    } else {
      return <div>No tasks yet...</div>;
    }
  };

  prevBtnClass = () => {
    if (this.props.currentPage !== 1) {
      return "protocol-btn";
    } else {
      return "protocol-btn hide";
    }
  };

  finalNextBtn = () => {
    return this.props.currentPage === this.props.totalPages;
  };

  backToNotebook = () => {
    this.props.setNoteBookSection("CONTEXT");
  };

  nextClicked = () => {

    if(this.finalNextBtn()){
      this.props.setNoteBookSection("RESULTS");
    } else {
      this.props.incProtocolPage();
      this.pageInstruction.focus();
      this.taskList.scrollTop = 0;
    }
  };

  prevClicked = () => {
    this.props.decProtocolPage();
    this.pageInstruction.focus();
    this.taskList.scrollTop = 0;
  };

  getCurrentTaskIndicator = () => {
    var page = 1;
    var task = 1;

    for (var i = 0; i < this.props.taskPages.length; i++) {
      var taskPage = this.props.tasks[i];

      if (
        this.props.focusedTask + 1 >= task &&
        this.props.focusedTask + 1 <= task + taskPage.tasks.length
      ) {
        return (
          page +
          "." +
          String.fromCharCode(97 + (this.props.focusedTask + 1) - task)
        );
      }
      page++;
      task += taskPage.tasks.length;
    }
  };

  getCurrentTaskPage = () => {
    var page = 1;
    var task = 1;

    for (var i = 0; i < this.props.taskPages.length; i++) {
      var taskPage = this.props.tasks[i];

      if (
        this.props.focusedTask + 1 >= task &&
        this.props.focusedTask + 1 <= task + taskPage.tasks.length
      ) {
        return page;
      }
      page++;
    }
  };

  showNotesView = () => {
    this.props.toggleNotesView(true);
  };

  componentWillMount() {
    //Setting total pages in prep for rendering Protocol View
    if (this.props.taskPages.length > 0) {
      this.props.setTotalProtocolPages(this.props.taskPages.length);
    }
  }

  componentDidMount() {
    this.props.focusFirstTask();

    this.viewProtocolRead();
  }

  viewProtocolRead = () =>{
    if(this.props.viewedProtocolReadDialog === true){
      return;
    }
    this.props.setModal({
      display: false,
      type: "PROTOCOL_READ",
      size: "md",
      connect: -1,
    });
    this.props.showModal({ display: true })
    this.props.setViewedProtocolReadDialog({ viewedProtocolReadDialog: true })
  }

  componentDidUpdate(prevProps, prevState) {
    // if(prevProps.modal.display === true && this.props.modal.display == undefined && this.props.modal.type === "PROTOCOL_READ"){
    //   this.pageInstruction.focus();
    // }
  }

  render() {
    return (
      <div>
        <NotesView />
        <div
          className="protocol-list-view"
          style={{ display: this.props.notesView ? "none" : null }}
        >
          <div className="protocol-head">
            <h4>
              <div className="hexagon">
                <IconHexagon
                  style={{ position: "absolute", top: "22px", left: "16px", color: 'white', height: '29px'}}
                />
              </div>
              <span className="listIndex">
                {this.props.sectionOption.number}
              </span>
              <button
                aria-label="Protocol menu button. Select to hide the Protocol instructions and simulation and display the menu."
                className="protocol-title-btn"
                onClick={this.backToNotebook}
              >
                Protocol
              </button>
              <LogEvent
                logEventProps={{
                  event_type: "sim_protocol_open_notes_btn clicked",
                  event_schema: "track"
                }}
                actionProps={{ onClick: { action: 'click' } }}
                elementType="button"
              >
                <button
                  onKeyDown={(e) => {
                    if (e.keyCode === 13 || e.keyCode === 32) this.showNotesView();
                  }}
                  onClick={this.showNotesView}
                  aria-label="Notes button. Select to display any notes you’ve made throughout the simulation."
                  className="protocol-notebook-btn"
                >
                  <IconNotebook
                    style={{ color: "white", height: "16px", top: "2px" }}
                  />{" "}
                  Notes
                </button>
              </LogEvent>
            </h4>
          </div>
          <div className="protocol-progress-container">
            {this.renderProgress()}
            {this.renderPageInstructions()}
          </div>
          <div
            className="protocol-content"
            ref={(taskList) => {
              this.taskList = taskList;
            }}
          >
            <div className="protocol-tasks-container">
              <ul>
                {this.renderTaskPage()}
              </ul>
            </div>
            <div className="protocol-btns-container">
              <LogEvent
                logEventProps={{
                  event_type: "sim_protocol_previous_part_btn clicked",
                  event_schema: "protocolpart",
                  part_number: this.props.currentPage
                }}
                actionProps={{ onClick: { action: 'clicked' } }}
                elementType="button"
              >
              <button
                aria-label="Previous button. Select to display the previous step in the protocol."
                className={this.prevBtnClass()}
                onClick={this.prevClicked}
                style={{
                  visibility:
                    this.props.currentPage === 1 ? "hidden" : "visible",
                }}
              >
                <IconStart
                  style={{
                    color: colors.navy1,
                    height: "16px",
                    top: "2px",
                    transform: "rotate(180deg)",
                  }}
                />{" "}
                Previous
              </button>
              </LogEvent>
              <LogEvent
                logEventProps={{
                  event_type: "sim_protocol_part viewed",
                  event_schema: "protocolpart",
                  part_number: this.props.currentPage
                }}
                actionProps={{ onClick: { action: 'clicked' } }}
                elementType="button"
              >
                <div
                  className="indicator"
                  onClick={() => {
                    this.props.goProtocolPage(this.props.focusedPage + 1);
                  }}
                >
                  <span>
                    {this.props.focusedPage +
                      1 +
                      "." +
                      String.fromCharCode(97 + this.props.focusedTask)}
                  </span>
                  <IconHexagon style={{ color: colors.navy1, height: "46px" }} />
                </div>
              </LogEvent>
              <LogEvent
                logEventProps={{
                  event_type: "sim_protocol_next_part_btn clicked",
                  event_schema: "protocolpart",
                  part_number: this.props.currentPage
                }}
                actionProps={{ onClick: { action: 'clicked' } }}
                elementType="button"
              >
                <button
                  aria-label="Next button. Select to display the next step in the protocol."
                  className={
                    "protocol-btn" +
                    (this.props.focusedPage >= this.props.currentPage ||
                    (this.props.currentPage === this.props.totalPages &&
                      this.props.taskPages[this.props.focusedPage].complete ===
                        true)
                      ? " active"
                      : "")
                  }
                  onClick={this.nextClicked}
                >
                  <IconStart
                    style={{ color: colors.navy1, height: "16px", top: "2px" }}
                  />
                  {this.finalNextBtn()?"Results":"Next"}
                </button>
              </LogEvent>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ProtocolOptions.defaultProps = {
  tasks: [],
};
